import {
  Nav,
  NavItem,
  Navbar
} from 'react-bootstrap';
import Routes from './Routes';
import React, { Component } from 'react';
import {
  withRouter,
  Link
} from 'react-router-dom';
import './App.css';
import config from './config.js';
import {CognitoAuth} from 'amazon-cognito-auth-js/dist/amazon-cognito-auth';

class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
          isLoadingUserToken: true,
          // Cognito auth library
          auth:  this.initCognitoSDK()
        };
    }

    handleNavLink = (event) => {
        event.preventDefault();
        this.props.history.push(event.currentTarget.getAttribute('href'));
    };

    handleLogout = (event) => {
        this.state.auth.signOut();
    };

    initCognitoSDK() {
        var authData = {
            ClientId : config.cognito.APP_CLIENT_ID,
            AppWebDomain : config.externalURL.SSO_URL,
            TokenScopesArray : ['openid'],
            RedirectUriSignIn : 'https://' + config.externalURL.wwwURL + '/Login',
            RedirectUriSignOut : 'https://' + config.externalURL.wwwURL,
            IdentityProvider : config.cognito.SAML_PROVIDER,
            UserPoolId : config.cognito.USER_POOL_ID,
            AdvancedSecurityDataCollectionFlag : 'true'
        };
        var auth = new CognitoAuth(authData);
        auth.useCodeGrantFlow();
        return auth;
    }

    handleLogin = async (event) =>{
      console.log(this.state.auth.getAppWebDomain());
      console.log(this.state.auth.getCurrentUser());
      console.log(this.state.auth.getLastUser());

      this.state.auth.getSession();
    };

    getUserSession = (auth) => {
      return new Promise((resolve, reject) => {
        auth.userhandler = {
          onSuccess: function(result) {
            resolve(result);
          },
          onFailure: function(err) {
            // alert("There was a problem authenticating your session.");
            reject(err);
          }
        };
        auth.getSession();
      });
    }

  // externally called as well
    getUserToken = async () => {
      let session = null;
      try {
        session = await this.getUserSession(this.state.auth);
      }catch(err) {
        console.log("There was a session error: ");
        console.log(err);
        try {
          JSON.parse(err);
        } catch (err2){
          console.log("There was a problem with parsing error description, likely session issues. Signing out.");
          this.state.auth.signOut();
          return null;
        }

        if (JSON.parse(err).error) {
          switch (JSON.parse(err).error) {
            // Corner case when token is cached, but Cognito user account has been deleted
            // More about Cognito error codes:
            // https://docs.aws.amazon.com/cognito/latest/developerguide/token-endpoint.html
            case "invalid_grant":
              alert('Your account no longer exists!');
              this.state.auth.signOut();
              return null;
            default:
              this.state.auth.signOut();
              return null;
          }
        } else {
          console.log("There was a problem with error description formt, likely session issues. Signing out.");
          this.state.auth.signOut();
          return null;
        }
      }
      this.setState({isLoadingUserToken: false});
      return session.getIdToken().getJwtToken();
    }

    async componentDidMount() {
      if (this.state.auth.getCurrentUser() === null) {
          this.setState({isLoadingUserToken: false});
          return;
      }
      // If user was there, try to init session
      await this.getUserToken();
    }


  render() {
    const childProps = {
      getUserToken: this.getUserToken,
      auth: this.state.auth,
    };
    return ! this.state.isLoadingUserToken
    &&
    (
      <div className="App container">
        <Navbar fluid collapseOnSelect fixedTop>
          <Navbar.Header>
            <Navbar.Brand>
              <Link to="/"><img className="nav-logo" alt="Riverbed" src="/riverbed_logo.png"></img>OAS</Link>
            </Navbar.Brand>
            <Navbar.Toggle />
          </Navbar.Header>
          <Navbar.Collapse>
            <Nav>
              <NavItem key={1} onClick={this.handleNavLink} href="/">Home</NavItem>
              { this.state.auth.isUserSignedIn()
                ? <NavItem onClick={(event) => {event.preventDefault(); window.open(config.externalURL.sfdcURL, "_blank");}}>Refresh Analytics</NavItem>
                : ""}
            </Nav>
            <Nav pullRight>
              <NavItem key={3} onClick={(event) => {event.preventDefault(); window.open(config.externalURL.supportURL, "_blank");}}>Support</NavItem>
              { this.state.auth.isUserSignedIn()
                ? <NavItem onClick={this.handleLogout}>Logout</NavItem>
                : [ <NavItem key={1} onClick={this.handleNavLink} href="/signup">Signup</NavItem>,
                    <NavItem key={2} onClick={this.handleLogin}>Login</NavItem> ] }
            </Nav>
          </Navbar.Collapse>
        </Navbar>
        <Routes childProps={childProps} />
        <div className="footer">
          <Navbar fluid collapseOnSelect fixedBottom>
            <Navbar.Text pullRight>
              <tr>
                <td>
                  Created by:
                </td>
                <td width="20px"></td>
                <td>
                  <a href="http://www.riverbed.com">Riverbed Inc</a>
                </td>
                <td width="20px"></td>
                <td>
                  Version:
                </td>
                <td width="20px"></td>
              </tr>
              <tr>
                <td>
                  <a href="https://www.linkedin.com/in/laurynask">Laurynas Kavaliauskas</a>
                </td>
                <td width="20px"></td>
                <td>
                  San Francisco, CA
                </td>
                <td width="20px"></td>
                <td>
                  {config.site.version}
                </td>
                <td width="20px"></td>
              </tr>
              <tr>
                <td>
                  <a href="https://uk.linkedin.com/in/mirceazetea">Mircea Zetea</a>
                </td>
                <td width="20px"></td>
                <td>
                  All Rights Reserved.
                </td>
                <td width="20px"></td>
                <td>
                  {config.site.build}
                </td>
                <td width="20px"></td>
              </tr>
            </Navbar.Text>
          </Navbar>
        </div>
      </div>
    );
  }
}


export default withRouter(App);



// WEBPACK FOOTER //
// ./src/App.js